import { DropdownOption } from './DropdownOption'

export interface IAdvancedSearchConfigurationDTO {
  id: string
  name: string
  advanceSearchQueryJson: string
  userId: string
  isGlobal: boolean
  selectedRoles: DropdownOption[]
  availableRoles: DropdownOption[]
  organizationId: string
}

export class AdvancedSearchConfigurationDTO implements IAdvancedSearchConfigurationDTO {
  public id: string
  public name: string
  public advanceSearchQueryJson: string
  public userId: string
  public isGlobal: boolean
  public selectedRoles: DropdownOption[]
  public availableRoles: DropdownOption[]
  public organizationId: string
}
